module.exports = __webpack_public_path__ + "img/img_cankao@2x.bced95e6.png";